import React from 'react';
import classNames from 'classnames/bind';
import { ButtonVariantType, Link, Text } from '@beef/ui-kit';

import { Card } from '../Card';
import { Image } from '../Image';
import styles from './styles.pcss';
import { FallbackBannerProps } from './types';

const cn = classNames.bind(styles);

export const FallbackBanner = ({
  className,
  title,
  buttonText,
  buttonLink,
  buttonVariant,
  source,
  onClick,
  children,
}: FallbackBannerProps) => (
  <Card className={cn('wrap', className)}>
    <div className={cn('content')}>
      <div className={cn('text-content')}>
        {title && (
          <div className={cn('title')}>
            <Text size="size2-m">{title}</Text>
          </div>
        )}
        {buttonText && buttonLink && (
          <>
            <a
              className={cn('link-fill')}
              data-component="app-fb-screen-reader-link"
              href={buttonLink}
            >
              <span className={cn('sr-only')}>{buttonText}</span>
            </a>
            <div className={cn('link')}>
              <Link
                buttonSize="l"
                buttonVariant={buttonVariant as ButtonVariantType}
                href={buttonLink}
                isFullWidth
                onClick={(e) => {
                  e.preventDefault();
                  if (onClick) {
                    onClick();
                  }
                  document.location.href = buttonLink;
                }}
                variant="button"
              >
                {buttonText}
              </Link>
            </div>
          </>
        )}
        {children && children}
      </div>
      {!!source && (
        <div className={cn('image')}>
          <picture>
            {source.map((item) => (
              <source key={item.media} media={`(${item.media})`} srcSet={item.srcset} />
            ))}
            <Image src={source[0].srcset} />
          </picture>
        </div>
      )}
    </div>
  </Card>
);
